<template>
  <div
    ref="watermarkBox"
    class="component-container"
    :class="{ 'watermask-full-screen': isFullScreen }"
    style="pointer-events: none"
  >
    <div ref="scrollNotice" class="notice scrolling-notice"></div>
    <div class="content-box" ref="contentBox"></div>
  </div>
</template>

<script>
import { createMarquee } from "@saas/components/src/utils/marquee";
import { createAnnouncementScroll } from "@saas/components/src/utils/announcement-scroll";

export default {
  props: {
    lessonDetail: {
      type: Object,
      default: () => {},
    },
    userName: {
      type: String,
      default: "-(-)",
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    riskConfigSwitch() {
      return this.lessonDetail.risk_control_switch;
    },
    riskConfig() {
      return this.lessonDetail.risk_control_config || {};
    },
  },
  watch: {
    lessonDetail: {
      handler(val) {
        if (val) {
          this.initMarquee();
          this.initAnnouncementScroll();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      marqueeInstance: null,
      announcementScrollInstance: null,
    };
  },
  beforeDestroy() {
    if (this.marqueeInstance) {
      this.marqueeInstance.destroy();
    }
  },
  mounted() {
    this.initMarquee();
    this.initAnnouncementScroll();
  },
  methods: {
    // 初始化跑马灯
    initMarquee() {
      if (
        !this.$refs.contentBox ||
        !this.lessonDetail.lesson_id ||
        this.riskConfigSwitch !== 1
      ) {
        return;
      }
      const marqueeSwitch = this.riskConfig.user_watermark_switch === 1;
      // 用户水印开启
      if (marqueeSwitch) {
        const densityMap = {
          1: "low",
          2: "medium",
          3: "high",
        };
        const mode =
          this.riskConfig.user_watermark_type === 1 ? "marquee" : "fixed";
        const density = this.riskConfig.user_watermark_density || 1;
        const opacity = this.riskConfig.user_watermark_diaphaneity || 50;
        this.marqueeInstance = createMarquee(
          this.$refs.contentBox,
          this.userName,
          {
            mode: mode,
            density: densityMap[density],
            color: "#000",
            opacity: opacity / 100,
          }
        );
        this.marqueeInstance.start();
      } else {
        if (this.marqueeInstance) {
          this.marqueeInstance.destroy();
        }
      }
    },
    initAnnouncementScroll() {
      if (
        !this.$refs.scrollNotice ||
        !this.lessonDetail.lesson_id ||
        this.riskConfigSwitch !== 1
      ) {
        return;
      }
      const copyRightSwitch = this.riskConfig.copyright_notice_switch === 1;
      // 版权声明开启
      if (copyRightSwitch) {
        const mode =
          this.riskConfig.copyright_notice_type === 1 ? "interval" : "infinite";
        const config = {
          color: "#fff",
          fontSize: "12px",
          mode: mode,
          interval: 1000 * 60 * 10,
          speed: 50,
          backgroundColor: "rgba(51, 51, 51, 0.2)",
        };
        const content = `【版权声明】本课程版权归${this.lessonDetail.org_name}所有，仅限个人学习，严禁任何形式的录制、传播和分享。`;
        this.announcementScrollInstance = createAnnouncementScroll(
          this.$refs.scrollNotice,
          [content],
          config
        );
        this.announcementScrollInstance.start();
      } else {
        if (this.announcementScrollInstance) {
          this.announcementScrollInstance.destroy();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.component-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.scrolling-notice {
  height: 28px;
  min-height: 28px;
  //   background: rgba(51, 51, 51, 0.2);
}
.content-box {
  flex: 1;
}
</style>
